import './DashboardCard.css';
import SideBoltIcon from '../../../assets/icons/side-bolt.svg?react';
import { useMemo } from 'react';

/**
 * OPM 전력계약 요약 (할당 EV 충전소 카드 레이아웃과 동일)
 * dashboardData: opmContractSummary, opmContractSummaryLoading, opmContractSummaryError
 */
const OpmContractSummaryCard = ({ colSpan = 1, rowSpan = 1, dashboardData = {} }) => {
  const { opmContractSummary, opmContractSummaryLoading, opmContractSummaryError } = dashboardData;

  const stats = useMemo(() => {
    if (!opmContractSummary) {
      return { total: 0, connected: 0, disconnected: 0 };
    }
    return {
      total: opmContractSummary.totalCount,
      connected: opmContractSummary.connectedCount,
      disconnected: opmContractSummary.disconnectedCount,
    };
  }, [opmContractSummary]);

  return (
    <div className="dashboard-card flex flex-col justify-between">
      <div className="icon-container icon-blue">
        <SideBoltIcon color="var(--badge-primary-600)" width={24} height={24} />
      </div>
      <div className="dashboard-card-content flex flex-col gap-10">
        <h3 className="text-b1-700 text-gray-600">할당된 OPM 고객계약번호</h3>
        {opmContractSummaryError && (
          <p className="text-b2-400 text-error">요약을 불러오지 못했습니다.</p>
        )}
        {!opmContractSummaryError && opmContractSummaryLoading && (
          <p className="text-b2-400 text-gray-600">불러오는 중…</p>
        )}
        {!opmContractSummaryError && !opmContractSummaryLoading && (
          <>
            <div className="flex flex-row align-center gap-10">
              <div className="text-h1 text-base">{stats.total}</div>
              <div className="charger-status flex gap-2">
                <span className="text-gray-600">
                  연결 <span className="text-green-400">{stats.connected}</span>
                </span>
                <span className="text-gray-600">
                  미연결 <span className="text-yellow-500">{stats.disconnected}</span>
                </span>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default OpmContractSummaryCard;
